import { findDropConfigById } from '@/config/drops'
import { DetailModal } from '../BrowserLayout/DetailModal'

export const InventoryBrowserDetailModal = ({
  selectedItem,
  details,
  close
}) => {
  const modalTheme = findDropConfigById(
    selectedItem?.active?.dropId || selectedItem?.active?.details?.drop_id
  )?.theme

  return (
    <DetailModal
      theme={modalTheme}
      overlayHeaderOpaqueOnScroll={true}
      title={{
        header: selectedItem?.active?.details.name,
        body: ''
      }}
      hide={close}
    >
      <div>{details(selectedItem?.active?.details, 'modal')}</div>
    </DetailModal>
  )
}
